export type HTTP_FETCH_CREDENTIALS = 'same-origin' | 'include' | 'omit'
export type HTTP_FETCH_REDIRECT = 'follow' | 'manual' | 'error'
export type HTTP_FETCH_REFERRER_POLICY = 'no-referrer'
export type HTTP_FETCH_MODE = 'cors' | 'no-cors' | 'same-origin'
export type HTTP_FETCH_CACHE_MODE = 'default' | 'no-cache' | 'reload' | 'force-cache' | 'only-if-cached'

export type StringOrNull = string | null
export type NumberOrNull = number | null
export type StringOrNumber = string | number

export const SPACE = ''

export const SDK_LOCAL_STORAGE_KEY = 'nugsnet:sdk:public:data'
export const SDK_CRYPTO_STORAGE_KEY = 'nugsnet:sdk:crypto:data'
export const SDK_TELEMETRY_STORAGE_KEY = 'nugsnet:sdk:telemetry'
export const OIDC_STORAGE_KEY = 'nugsnet:sdk:oidc'
export const CACHE_LINKS_KEY = 'nugsnet:cache:links'

export const API_VERSION = '1' // Example

export const OIDC_SERVICE = 'OIDC_SERVICE'
export const LEGACY_API_SERVICE = 'LEGACY_API_SERVICE'
export const SDK_CONFIG_SERVICE = 'SDK_CONFIG_SERVICE'
export const SDK_ACCOUNT = 'SDK_ACCOUNT'
export const PLAYBACK_SESSION_SERVICE = 'PLAYBACK_SESSION_SERVICE'

export const CONCURRENCY_PLAYBACK_TOKEN_KEY = 'nugsnet:sdk:concurrency:token'

export const UUID_KEY = 'uuid'

export const CLIP_URL_KEY = 'data-clip'

export const START_TIME = '00:00'

export const timelineAnimationOptions = { duration: 50, easing: 'linear', fill: 'both' } as KeyframeAnimationOptions

export const SDK_CLOSE_POPUP_EVENT = 'web-sdk:popup:close'

export const CLOUDFLARE_CDN_URL = 'https://cdnjs.cloudflare.com'

export const AMPLITUDE_LIBRARY_URL = 'https://cdn.amplitude.com/libs/amplitude-8.21.4-min.gz.js'
export const AMPLITUDE_INSTANCE_KEY = 'nugsnet:sdk:amplitude'
